
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbTooltip } from '@commonNodeModules/@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';

@Component({
	selector: 'app-reset-filter',
	templateUrl: './reset-filter.component.html',
	styleUrls: ['./reset-filter.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgbTooltip, TranslatePipe]
})
export class ResetFilterComponent implements OnInit {
	@Input() active: boolean;
	@Output() resetFilter = new EventEmitter();
	constructor() { }

	ngOnInit(): void {
	}

}
